import { render, staticRenderFns } from "./GameDataOneShot.vue?vue&type=template&id=0d6dfe72&"
import script from "./GameDataOneShot.vue?vue&type=script&lang=js&"
export * from "./GameDataOneShot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports